export class BackupPoliciesLimits {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "maxRetentionDays",
            "baseName": "maxRetentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPoliciesLimits.attributeTypeMap;
    }
    constructor() {
    }
}
